const businessReducer = (state, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.data };
    case "FETCH_BUSINESS":
      return { ...state, businessData: action.data, loading: false };
    case "FETCH_TEAM":
      return { ...state, team: action.data };
    case "FETCH_SERVICES":
      return { ...state, services: action.data };
    case "RESET_SERVICES":
      return { ...state, services: [] };
    case "FETCH_OPENING_HOURS":
      return { ...state, openingHours: Object.values(action.data) };
      case "FETCH_DATES":
        return { ...state, unavailableDates: Object.values(action.data) };
    case "RESET_OPENING_HOURS":
      return { ...state, openingHours: null, availableSeats: null };
    case "SET_AVAILABLE_SEATS":
      return { ...state, availableSeats: action.data };

    default:
      return state;
  }
};

export default businessReducer;
